import { _project }          from 'state/store.projects'
import { _bootstrap }        from 'state/store.bootstrap'
import { get, getFocus, useGet }       from 'state/jotai'
import { WDay, MDay, Month } from './OpenHouseBanner.utilities'
import { active_project } from 'state/store.global'
import { useEffect, useState } from 'react'
import { useActiveUnit } from 'components/Unit'

export const useOpenHouseData = () => {
  const unit       = useActiveUnit();
  const sitename   = useGet(_bootstrap).sitename
  const openhouse  = get(_project, 'openhouse')
  const openhouses = get(_project, 'openhouses')

  const [cOpHouse, setCOphouse] = useState({})
 
  const { pin, pid } = useGet(active_project)
  const buttonsLabel = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []

  useEffect(()=> {
    const cop_hsg = openhouses.filter((oh)=> oh.ProjectID == unit?.data?.ProjectID)
    setCOphouse(cop_hsg?.[0])
  }, [unit?.data?.UnitID])

  const Y = sitename ?? ''
  const A = cOpHouse?.FromDate    || ''
  const P = cOpHouse?.FromDate    || ''  // Remember safari requires specific format of dates
  const X = cOpHouse?.Title       || ''
  const W = cOpHouse?.FromTime    || ''
  const V = cOpHouse?.ToTime      || ''
  const I = cOpHouse?.Address
    // const I = buttonsLabel?.filter( btn => btn?.UILabelProperty == 'OpenHouseAddress')[0]?.Label || ''
  const K = cOpHouse?.Description || ''
    // const url = openhouse?.url || ''

  const Q = `${MDay(P) ?? ''}`
  const R = `${Month(P) ?? ''}`
  const S = `${Y}`
  const T = `${WDay(P)[0].toUpperCase() + WDay(P).slice(1).toLowerCase()} ${buttonsLabel?.filter( btn => btn?.UILabelProperty == 'kl')[0]?.Label} ${W} - ${V}`
  const U = `${I}`
  const L = `${K}`
  

  return {
    ready      : W && V,
    STime      : W,
    ETime      : V,
    MM         : Q,
    MMM        : R,
    Title      : S,
    Ftitle     : X,
    Time       : T,
    Address    : U,
    Description: L,
    Date       : A
      // Url        : url
  }


}